<template>
  <div>
    <BreadCrumb :data="breadCrumb" />

    <b-card class="formGroup">
      <Form ref="MovementForm"  :forms="MovementForm" />
      <template v-slot:footer class="footerButtons">
        <b-button :disabled='isLoading' variant="primary" @click="saveForm">Kaydet</b-button>
      </template>
    </b-card>
  </div>
</template>

<script>
let breadCrumb = [
  { label: 'Stoklar', url: "/Stock/List" },
  { label: 'Hareketler', url: "/Stock/Movements" },
  { label: 'Ekle', url: "/Stock/Movements/Add" },
];

import BreadCrumb from '@/components/BreadCrumb'
import Form from '@/components/Form'
import {prepareRequestData} from '@/assets/js/custom.js'
import Forms from './forms'
export default {
  components: {
    BreadCrumb, Form
  },
  computed: {
    isLoading() {
      return this.$store.getters.getStockLoading
    },
  },
  data() {
    return {
      breadCrumb,
      MovementForm: Forms.Movement
    }
  },
  methods:{
    saveForm() {
      this.$refs.MovementForm.$refs.Form.validate().then(async (success) => {
        if (success) {
          const data = prepareRequestData(this.MovementForm, this.$refs.MovementForm.formData)
          await this.$store.dispatch('stockMovement', data)

          if( this.$store.getters.getStockStatus.status == 'Success') {
            await this.$store.dispatch('fetchMovements')
            return this.$router.push('/Stock/Movements')
          }

          this.saveState(false)
        }
      });
  }
}
}
</script>

<style>
    @import "./styles/add.min.css"; 

</style>


// WEBPACK FOOTER //
// src/pages/ERP/Stock/MovementsAdd.vue